import { render } from "./Sites.vue?vue&type=template&id=d2ec3f28"
import script from "./Sites.vue?vue&type=script&lang=js"
export * from "./Sites.vue?vue&type=script&lang=js"

import "./Sites.vue?vue&type=style&index=0&id=d2ec3f28&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__